import { useQuery } from '@apollo/client';
import type { UseInventoryListFetchById } from '@openx/components-administration/lib/utils/context/InventoryListHookTypes';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { GetInventoryListByIdDocument } from '../../../../graphql/query/inventoryList/GetInventoryListById.generated';
import { useLocalErrorHandling } from '../../../../modules/graphql/useLocalErrorHandling';

export const useInventoryListByIdFetch: UseInventoryListFetchById = (id = '') => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  useLocalErrorHandling(GetInventoryListByIdDocument, () => true);

  const { data, loading } = useQuery(GetInventoryListByIdDocument, {
    variables: { id: parseInt(id ?? '', 10) },
    skip: !id,
    fetchPolicy: 'network-only',
    onError: () => {
      enqueueSnackbar(t('Failed to fetch Inventory List'), { variant: 'error' });
    },
  });

  return { loading, inventoryList: data?.inventorylist?.objects[0] || null };
};
